import React from 'react';
import { getUrlParam, getSwitchAccountDomain, isKlarityHost } from 'utils/common';
import { ERegisterType } from 'api/public';
import s from './index.module.less';
import kiwiLogo from './imgs/kiwi.svg';
import klarityLogo from './imgs/klarity.svg';
import { PATH } from 'constants/path';

const SwitchAccountNoticePage = () => {
    const accountType = getUrlParam('accountType');

    const isKlarityAccount = accountType === ERegisterType.KLARITY_PORTAL ||
        (!accountType && isKlarityHost());

    const getLoginUrl = () => {
        if (isKlarityAccount) {
            const domain = getSwitchAccountDomain(false);
            return domain ? `https://${domain}${PATH.PPA_LOGIN}` : PATH.PPA_LOGIN;
        } else {
            const domain = getSwitchAccountDomain(true);
            return domain
                ? `https://${domain}/${PATH.PROVIDER_LOGIN}`
                : `/${PATH.PROVIDER_LOGIN}`;
        }
    };

    const handleLoginClick = () => {
        window.location.href = getLoginUrl();
    };

    return (
        <div className={s.container}>
            {/* 主要内容 */}
            <div className={s.content}>
                {/* Logo 区域 */}
                <div className={s.logoContainer}>
                    <div className={s.logoBackground}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="120"
                            height="119"
                            viewBox="0 0 120 119"
                            fill="none"
                        >
                            <circle
                                cx="60"
                                cy="59.5"
                                r="57"
                                stroke="#DCF2FF"
                                strokeWidth="5"
                                strokeDasharray="10 10"
                            />
                        </svg>
                        <img
                            className={
                                isKlarityAccount ? s.klarityLogo : s.kiwiLogo
                            }
                            src={isKlarityAccount ? klarityLogo : kiwiLogo}
                            alt="Logo"
                        />
                    </div>
                </div>

                {/* 文本内容 */}
                <div className={s.textContent}>
                    <h1 className={s.title}>
                        {isKlarityAccount
                            ? 'Login to your Klarity account'
                            : 'Login to your Kiwi account'}
                    </h1>
                    <p className={s.description}>
                        {isKlarityAccount
                            ? 'Please click the link below to log in with your Klarity email and password.'
                            : 'Please click the link below to log in with your Kiwi email and password.'}
                    </p>
                </div>

                {/* 登录链接 */}
                <div className={s.loginLinkContainer}>
                    <button
                        type="button"
                        className={s.loginLink}
                        onClick={handleLoginClick}
                    >
                        {getLoginUrl()}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SwitchAccountNoticePage;
